module.exports = __webpack_public_path__ + "img/result-duration.8728f0c4.png";